<div class="sidebar-login">
	<img class="logo" src="/resources/img/logo/logo_blue.svg" alt="logo" />
	<div class="tagline">{{ tagLine | translate }}</div>
	<div class="img-container">
		<!-- < 2350 width screen use lower resolution img -->
		<img src="/resources/img/login/login-image-{{imageNumber}}.jpeg"
			srcset="/resources/img/login/login-image-{{imageNumber}}-600px.jpeg 600w, /resources/img/login/login-image-{{imageNumber}}.jpeg 1500w"
			sizes="(max-width: 2350px) 600px, 1500px" alt="" />
		<div class="black-line"></div>
	</div>
</div>
